<mat-card
    class="daxa-card settings-card mb-3 border-radius bg-white border-none d-block"
    [class.component-dark-theme]="themeService.isDark()"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>

<mat-tab-group>
    <mat-tab label="Détails du Client">
        <ng-template matTabContent>
            <app-client-details [id]="id" />
        </ng-template>
    </mat-tab>

    <mat-tab label="Contacts">
        <ng-template matTabContent>
            <app-client-poc-details [id]="id"/>
        </ng-template>
    </mat-tab>

    <mat-tab label="Exploitations">
        <ng-template matTabContent>
            <app-clients-exploitation-details [id]="id"/>
        </ng-template>
    </mat-tab>

    <mat-tab label="Terrain">
        <ng-template matTabContent>
            <app-clients-terrain-details [id]="id"/>
        </ng-template>
    </mat-tab>

    <mat-tab label="Échantillon">
        <ng-template matTabContent>
            <router-outlet></router-outlet>
            <app-clients-sample-details [id]="id"/>
        </ng-template>
    </mat-tab>
    <mat-tab label="Rapport">
        <ng-template matTabContent>
            <router-outlet></router-outlet>
            <app-clients-rapport-details [id]="id"/>
        </ng-template>
    </mat-tab>

</mat-tab-group>

</mat-card>
